class Cache {

    get(key) {
        if (key in OD.initialState.cache) {
            let val = OD.initialState.cache[key]
            delete OD.initialState.cache[key]
            return {[key]: val}
        }
        return false;
    }
}

export default new Cache()